module.exports = __webpack_public_path__ + "img/onlinePlatformBg-lg.ace3329e.jpg";